import { useTranslation } from 'react-i18next';
import { PageHeading } from '@hp/ui';
import { useCan } from '../api/me';
import { useProjects } from '../features/projects/queries';
import { ErrorAlert } from '../components/error-alert';
import { NewProjectPanel } from '../features/projects/new-project-panel';
import { ProjectTable } from '../features/projects/project-table';

export default function Projects() {
  const { t } = useTranslation(['projects', 'common']);
  const projects = useProjects();
  const canEdit = useCan()('projects.edit');

  return (
    <div className="bo-sections">
      <PageHeading title={t('list.title')} description={t('list.description')} />

      {canEdit && <NewProjectPanel />}

      <ErrorAlert error={projects.error} />

      <ProjectTable projects={projects.data ?? []} isLoading={projects.isLoading} />
    </div>
  );
}
